import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import vuetify from './plugins/vuetify';
import VueSimpleAlert from "vue-simple-alert";
import VuePlyr from 'vue-plyr'

Vue.use(VueSimpleAlert);

Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: false }
  }
})

Vue.config.productionTip = false;
//axios.defaults.baseURL='http://localhost:3000/';
// axios.defaults.baseURL = 'https://almacenv1demo.carexlogistics.es/';
 axios.defaults.baseURL='https://almacenserviplas.apps360.es/';

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');

